import * as React from 'react';
import { AnimatedTabs } from '../AnimatedTabs';
import { PersonalDataTab } from './PersonalDataTab';
import {
    IApiError,
    IExamList, IExamsFilters, IExpertChangeRequests,
    IExpertDetails,
} from '../models';
import AscParticipationTab from './AscParticipationTab/AscParticipationTab';
import { ExpertQualifications } from './ExpertQualifications';
import { Tab } from 'react-bootstrap';
import { Exams } from './Exams';
import ChangesHistoryTab from './ChangesHistoryTab/ChangesHistoryTab';
import { IFromToDatePart, IFullSearchPart, IIdFilter } from '../reduxModels';

const ExpertDetailsTabs: React.FC<IProps> = (props) => {
    const tabs = [
        {
            tab: 'Информация',
            title: 'Личные данные члена комиссии',
            category: 'Общая информация о члене комиссии',
           ...(props.tabsDescription ? props.tabsDescription.personalData || {} : {}),
            key: 'personalData',
            render: (tabDescription: DescriptionType) => (
              <PersonalDataTab
                cardTitle={tabDescription.title}
                cardCategory={tabDescription.category}
                personalData={props.details}
                headerChild={props.personalDataTabHeaderChild}
              />
            ),
        },
        {
            tab: 'Участие в комиссиях',
            title: 'Участие в комиссиях',
            category: 'Список всех комиссий и статусов',
            ...(props.tabsDescription ? props.tabsDescription.asc || {} : {}),
            key: 'asc',
            render: (tabDescription: DescriptionType) => (props.details ? (
              <AscParticipationTab
                title={tabDescription.title}
                category={tabDescription.category}
                linkedExpertStatusesDetails={props.details.linkedExpertStatusesDetails}
              />
            ) : null),
        },
        {
            tab: 'Специальности',
            title: 'Специальности члена комиссии',
            category: 'Список всех специальностей члена комиссии',
            ...(props.tabsDescription ? props.tabsDescription.qualifications || {} : {}),
            key: 'qualifications',
            render: (tabDescription: DescriptionType) => (props.details ? (
              <ExpertQualifications
                apiError={props.apiError}
                cardTitle={tabDescription.title}
                cardCategory={tabDescription.category}
                qualificationsList={props.details.qualifications}
              />
            ) : null),
        },
        {
            tab: 'Аккредитации',
            title: 'Аккредитации члена комиссии',
            category: 'Список аккредитаций, в которых участвовал член комиссии',
            ...(props.tabsDescription ? props.tabsDescription.exams || {} : {}),
            key: 'exams',
            render: (tabDescription: DescriptionType) => (props.details ? (
              <Exams
                cardTitle={tabDescription.title}
                cardCategory={tabDescription.category}
                examsList={props.exams}
                getList={props.getExams}
              />
            ) : null),
        },
        {
            tab: 'История назначений',
            title: 'История назначений',
            category: 'История включений/исключений из составов комиссий',
            ...(props.tabsDescription ? props.tabsDescription.history || {} : {}),
            key: 'history',
            render: (tabDescription: DescriptionType) => (props.details ? (
              <ChangesHistoryTab
                title={tabDescription.title}
                category={tabDescription.category}
                expertId={props.details.id}
                getExpertChangeRequestsHistory={props.getExpertChangeRequestsHistory}
                clearExpertChangeRequestsHistory={props.clearExpertChangeRequestsHistory}
                expertChanges={props.historyExpertChanges}
                apiError={props.apiError}
              />
            ) : null),
        },
    ];
    const nodes = tabs.filter(t => !t.hide);
    return (
      <AnimatedTabs
        id="ExpertContainerTabs"
        defaultActiveKey={props.defaultActiveKey || 'personalData'}
      >
          {nodes.map(n => (
            <Tab eventKey={n.key} title={n.tab} key={n.key}>
                {n.render(n)}
            </Tab>
          ))}
      </AnimatedTabs>
    );
};

interface IProps {
    tabsDescription?: TabsDescriptionTypes;
    defaultActiveKey?: TabsType;
    details: IExpertDetails | null;

    // Exams
    exams?: IExamList | null;
    getExams?: (payload: IExamsFilters) => void;

    apiError: IApiError | null;

    historyExpertChanges: IExpertChangeRequests | null;
    getExpertChangeRequestsHistory: (payload: IIdFilter & IFullSearchPart & IFromToDatePart) => Promise<void>;
    clearExpertChangeRequestsHistory: () => void;

    personalDataTabHeaderChild?: React.ReactNode;
}

type TabsType = 'personalData' | 'qualifications' | 'asc' | 'exams' | 'history';
interface DescriptionType {
    hide?: boolean;
    tab?: string;
    title?: string;
    category?: string;
}

type TabsDescriptionTypes = Record<TabsType, DescriptionType>

export default ExpertDetailsTabs;
